export const bank = [
    'BCI',
    'BNC',
    'BNP',
    'OPT',
    'SGB',
    ];